export default __webpack_public_path__ + "static/media/8.88e6f629.jpg";